<div data-testing-id="cart-page">
  <div class="cart-header col-xs-12">
    <h1 class="flex-wrap align-items-baseline text-center text-capitalize font-50 shopping-cart-header">
      <span class="cart-header-title">{{ 'shopping_cart.heading' | translate }}</span>
      <!--       <span class="header-note">
        <span>{{ 'shopping_cart.transaction.text' | translate }}</span>
        <ish-modal-dialog-link linkText="shopping_cart.read_more.link"
          [options]="{ titleText: 'checkout.safeandsecure.details.title' | translate, size: 'lg' }"
          class="details-link">
          <ish-content-include includeId="include.dialog.safeAndSecure.pagelet2-Include" *ishLazyLoadingContent>
          </ish-content-include>
        </ish-modal-dialog-link>
      </span> -->
    </h1>
  </div>

  <div>
    <!-- Error message -->
    <ish-error-message *ngIf="error?.message" [error]="error" />

    <ish-basket-error-message [error]="error" />

    <!-- Basket Info messages -->
    <ish-basket-info />

    <!-- Validation messages-->
    <ish-basket-validation-results />

    <!-- Dynamic Promotion Message -->
    <div *ngIf="basket?.dynamicMessages?.length" class="alert alert-info">
      <ul class="list-unstyled">
        <li *ngFor="let msg of basket.dynamicMessages">
          <span *ngIf="msg" [ishServerHtml]="msg"></span>
        </li>
      </ul>
    </div>
  </div>

  <!-- <custom-lazy-save-for-later-messages></custom-lazy-save-for-later-messages> -->

  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12 col-lg-8 cart-lineitem-section">
        <div class="marketing-area">
          <ish-content-include includeId="include.basket.content.top.pagelet2-Include" />
        </div>

        <div class="cost-center-select">
          <ish-basket-cost-center-selection />
        </div>
        <div class="section">
          <ng-container *ishFeature="'quoting'; else elseTemplate">
            <ish-lazy-quoting-basket-line-items />
          </ng-container>
          <ng-template #elseTemplate>
            <ish-line-item-list *ngIf="basket" [lineItems]="basket.lineItems" />
          </ng-template>

          <ish-loading *ngIf="loading" />
          <div class="row shopping-cart-button-group">
            <div class="col-12 col-md-6 col-lg-6">
              <button routerLink="/home" class="text-nowrap btn btn-secondary no-print">
                {{ 'shopping_cart.detailed.continue_shopping.link' | translate }}
              </button>
            </div>
            <div class="col-12 col-md-6 col-lg-6 clear-cart">
              <!-- <custom-lazy-clear-cart></custom-lazy-clear-cart> -->
              <ish-clear-basket />
            </div>
          </div>

          <div class="button-group">
            <ish-lazy-basket-add-to-quote />
            <ish-lazy-basket-create-order-template
              *ngIf="basket"
              [cssClass]="'btn btn-secondary'"
              [products]="basket.lineItems"
            />
            <custom-lazy-basket-create-wishlist [cssClass]="'btn btn-secondary'" [products]="basket.lineItems" />
          </div>
        </div>
        <!-- Removed direct order for dias customization
          <ish-lazy-direct-order></ish-lazy-direct-order>
        -->

        <div class="marketing-area">
          <ish-content-include includeId="include.basket.content.bottom.pagelet2-Include" />
        </div>
      </div>

      <div class="col-md-12 col-lg-4 order-summary">
        <custom-forgot-something />

        <!-- <h2>{{ 'checkout.order_details.heading' | translate }}</h2> -->
        <div class="cart-order-summary">
          <div class="cost-summary">
            <!-- Cost Summary Component -->
            <h4 class="order-summary-heading">Summary</h4>
            <ish-basket-cost-summary [totals]="basket.totals" />

            <ish-basket-promotion-code />

            <!-- ToDo: ISREST-275: disable button if basket max value is exceeded -->
            <button
              *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']"
              type="submit"
              class="btn btn-lg btn-block btn-primary"
              (click)="checkout()"
            >
              {{ 'shopping_cart.proceed_to_checkout.button.label' | translate }}
            </button>

            <custom-lazy-multiple-shipping-checkout-button />

            <ish-lazy-punchout-transfer-basket *ishIsAuthorizedTo="'APP_B2B_SEND_PUNCHOUT_BASKET'" />
            <!--COMMENTED OUT TILL ICM 12 AVAILABLE-->
            <ish-shopping-basket-payment *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']" [basket]="basket" />
          </div>
        </div>

        <!-- <ish-basket-promotion-code></ish-basket-promotion-code> -->

        <div class="marketing-area">
          <ish-content-include includeId="include.basket.ordersummary.pagelet2-Include" />
        </div>
      </div>
    </div>
  </div>
</div>
